import React from 'react';
import { Link } from 'react-router-dom';
import { filterAndCleanCategories } from '../../utils/categoryUtils';

const CategoryGrid = ({ featured_categories, app_site_storage_path }) => {
    const cleanedCategories = filterAndCleanCategories(featured_categories, '[valuefinds]');

    return (
        <div className="holder holder-mt-small" id="holderCollectionGrid">
            <div className="container">
                <div className="collection-grid-2 row justify-content-center">
                    {cleanedCategories.map(el => (
                        <div className="collection-grid-2-item col-9 col-md-quarter col-lg-3" key={el.id}>
                            <Link
                                to={`/product-listing?category_id=${el.id}`}
                                className="bnr-wrap collection-grid-2-item-inside"
                            >
                                <div className="collection-grid-2-img image-container image-hover-scale"
                                    style={{ paddingBottom: '77.778%' }}>
                                    <div className="product-image" style={{ backgroundImage: `url('${app_site_storage_path}${el.file_name}')` }}>
                                        <img src="/images/skins/electronics/category-img-01.png"
                                            alt={el.name}
                                            className="js-prd-imggg" />
                                    </div>
                                </div>
                                <h3 className="collection-grid-2-title pb-15 heading-font">{el.name}</h3>
                            </Link>
                        </div>
                    ))}
                </div>
                <style dangerouslySetInnerHTML={{ __html: "\n\t\t\t#holderCollectionGrid .collection-grid-2-title {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tcolor: #464b5c\n\t\t\t}\n\t\t\t#holderCollectionGrid .collection-grid-2-title:hover {\n\t\t\t\tcolor: #464b5c\n\t\t\t}\n\t\t" }} />
            </div>
        </div>
    );
};

export default CategoryGrid;
